import React from "react";
import logo from "../../img/integrator_logo.png";
import "./Header.css";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faAlignJustify } from "@fortawesome/free-solid-svg-icons";

import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink
} from "reactstrap";

library.add(faAlignJustify);

export default class HeaderSticky extends React.Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    return (
      <Container className="headersticky">
        <Navbar color="dark" dark expand="md">
          <NavbarBrand href="/">
            <img src={logo} className="img-fluid logo" alt="Integrator" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="mr-auto" navbar>
              <NavItem>
                <NavLink href="/get-certified">Get Certified</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/business-benefits">Business Benefits </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/events">Schedule </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/aboutus">About Us </NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/community">Community </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </Container>
    );
  }
}
